import Flickity from 'flickity';
import $ from 'jquery';

$(document).ready(function() {
  const $slider = $('.m-box-slider .slider-container .row');

  //
  $slider.each(function() {
    const $thisSlider = $(this);
    const slider = $thisSlider[0];

    //
    const flkty = new Flickity(slider, {
      cellSelector: '.slide',
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: true
    });
  });
});



// WEBPACK FOOTER //
// ./app/ui/modules/box-slider/index.js